import { Component } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { LugaresService } from '../services/lugares.service';

@Component({
  selector: 'app-detalle',
  templateUrl: './detalle.component.html',

})
export class DetalleComponent{
  lat:number=-33.4013924;//latitud para cargar el marcador en el mapa
  lng:number=-70.6438089;//longitud para cargar el marcador en el mapa
id = null;//definimos el id como null
lugar:any = {};//definimoslugar como un objeto de tipo any
constructor(private route: ActivatedRoute, private lugaresServices: LugaresService){
//  console.log(this.route.snapshot.params['id']);

  this.id = this.route.snapshot.params['id'];//asiganos el valor del id a la variable id
  this.lugaresServices.getLugar(this.id)//enviamos el id al metodo getLugar de nuestro lugaresServices
  .valueChanges().subscribe(lugar => {
    this.lugar = lugar;

  });

}


}



// WEBPACK FOOTER //
// C:/Users/xikoo/Desktop/cursoAngular4/src/app/detalle/detalle.component.ts